/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgCode： 图片验证码地址
 * clickUrl: 菜单点击地址
 *
 */
let backUrl;
let mainUrl;
let ssoUrl;
let clickUrl;
let downloadUrl;
let ossUrl;
let adminAccount;
let allSessionId;
if (process.env.NODE_ENV == 'development') {
  backUrl = 'http://test-pk-ht.hzqisheng.cn/'
  // ssoUrl = 'http://47.97.104.158:12080'//正式网
  mainUrl = 'http://test-user-center.test176.cn/'
  ossUrl = 'http://test-mh-company.test176.cn';//测式网
  ssoUrl = 'http://47.98.61.135:12080/'//测式网
  clickUrl= 'http://localhost:'
  downloadUrl = 'http://192.168.0.188:8088/park_cms/';




    // adminAccount = "zyh";
    // allSessionId = "2855E6A721FF349764CF47B4E1A741C9";//todo 该id失效时，请到相应测试网或正式网获取
    // sessionStorage.setItem("adminAccount", adminAccount);
    // sessionStorage.setItem("allSessionId", allSessionId);
}else{
  backUrl = '/'
  clickUrl=''
  ossUrl = window.location.origin;
  downloadUrl = 'http://test-pk-ht.hzqisheng.cn/'// todo 测式网
  if (process.env.HOST == "test") {
    mainUrl = 'http://test-user-center.test176.cn/'//测式网
    ssoUrl = 'http://47.98.61.135:12080/'//测式网
  } else if (process.env.HOST == "trial") {
    mainUrl = "http://prep-center.zhihuipk.com/";//预生产
    ssoUrl = "http://prep-center.zhihuipk.com/";//预生产
  } else if (process.env.HOST == "pro") {
    mainUrl = 'http://user-center.zhihuipk.com/'//正式网
    ssoUrl = 'http://user-center.zhihuipk.com/'//正式网
  }
}

export {
  backUrl,
  ssoUrl,
  mainUrl,
  clickUrl,
  downloadUrl,
  ossUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js